import { render } from "./PrivacyMain.vue?vue&type=template&id=61783b8a&scoped=true"
import script from "./PrivacyMain.vue?vue&type=script&lang=js"
export * from "./PrivacyMain.vue?vue&type=script&lang=js"

import "./PrivacyMain.vue?vue&type=style&index=0&id=61783b8a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61783b8a"]])

export default __exports__